import axiosInstance from 'helpers/axiosInstance';

import { UserAccount } from './account.types';

export const getCurrentAccount = () => {
  return axiosInstance
    .get<{ account: UserAccount }>('/patients/accounts/current')
    .then(d => d.data.account);
};
